.checkboxContainer {
  display: inline-block !important;
  position: relative !important;
  width: 24px !important;
  height: 24px !important;
  margin: 0 !important;
  padding: 4 !important;
  box-sizing: border-box !important;
}

.checkboxContainer input[type="checkbox"] {
  opacity: 0 !important;
  position: absolute !important;
  width: 0 !important;
  height: 0 !important;
  margin: 0 !important;
}

.checkboxContainer::before {
  content: "" !important;
  display: block !important;
  width: 100% !important;
  height: 100% !important;
  border: 2px solid black !important;
  border-radius: 50% !important;
  box-sizing: border-box !important;
  background-color: var(--st-select-inactive) !important;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease !important;
}

.checkboxContainer:has(input[type="checkbox"]:checked)::before {
  border-color: black !important;
  background-color: var(--st-select-active) !important;
}

.checkboxContainer:has(input[type="checkbox"]:indeterminate)::before {
  border-color: black !important;
  background: linear-gradient(
    135deg,
    var(--st-select-inactive) 50%,
    var(--st-select-active) 50%
  ) !important;
}
